import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Cacto from '../../../front-novo/icons/Cacto.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';

function Home2() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <img src={Cacto} />
          <p>
            A Biblioteca Virgínia Bicudo foi criada para democratizar o acesso a
            materiais e conteúdos em psicanálise. Nossa coleção inclui uma
            variedade de artigos e livros sobre o tema, além de trabalhos dos
            fundadores e participantes do Travessias.
            <br />
            <br />
            Nomeada em homenagem a Virginia Leone Bicudo, a biblioteca celebra
            uma analista didata e pioneira que desempenhou um papel central na
            expansão da psicanálise no Brasil. Nascida em 1910, Virgínia Bicudo
            foi a primeira psicanalista não médica do país e teve uma trajetória
            marcante na educação e na formação de novos analistas. Seu trabalho
            foi fundamental para a difusão da psicanálise e para a inclusão de
            diversas perspectivas teóricas na prática clínica.
          </p>
          {/* <a href="https://drive.google.com/drive/folders/1V6HzMm1dAmu2HPSSVUrEMyRXP4oNAKsP">
            <button>Acesse agora</button>
          </a> */}
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home2;
